import { createScopedTranslationKeys } from '@dreryk/react-common';

export const translations = {
   pl: {
      '~libs.desktop.adamed-expert': {
         button: 'ADAMED EXPERT',
         externalSystemBusinessFault: 'Treść komunikatu Adamed Expert: {{messageFromAdamedExpert}}',
         loading: 'Proszę czekać, trwa przekierowanie do Adamed Expert',
         modal: {
            authenticate: {
               invalidCredentialsFault: 'Niepoprawne dane logowania',
               logIn: 'Zaloguj się do Adamed Expert',
               register: {
                  info: 'Nie masz jeszcze konta w Adamed Expert? ',
                  link: 'Zarejestruj się',
               },
               rememberMe: 'Zapamiętaj mnie',
            },
            emailAddress: 'Adres e-mail',
            emailPlaceholder: 'Wpisz adres e-mail do serwisu Adamed Expert',
            fetchError: 'Nie powiodło się pobranie danych z serwisu Adamed Expert',
            info: {
               AUTHENTICATE: 'Zaloguj się do serwisu Adamed Expert i sprawdź, co nowego.',
               REGISTER: 'Zarejestruj się i uzyskaj dostęp do materiałów dla specjalisty.',
            },
            navigate: {
               AUTHENTICATE: {
                  info: 'Nie masz jeszcze konta w Adamed Expert?',
                  link: 'Zarejestruj się',
               },
               REGISTER: {
                  info: 'Masz już konto w Adamed Expert?',
                  link: 'Zaloguj się',
               },
            },
            password: 'Hasło',
            passwordNotMatchingRestrictions:
               'Hasło musi składać się z co najmniej 8 znaków, zawierać małe i wielkie litery, cyfry oraz znaki specjalne',
            passwordPlaceholder: 'Wprowadź hasło do serwisu Adamed Expert...',
            register: {
               birthDate: 'Data urodzenia',
               medicalLicenceNumber: 'NPWZ',
               phoneNumber: 'Numer telefonu',
               register: 'Zarejestruj się do Adamed Expert',
            },
            rememberMe: 'Zapamiętaj mnie',
         },
      },
   },
};

export const translationKeys = createScopedTranslationKeys(translations.pl, '~libs.desktop.adamed-expert');
